module.exports = __webpack_public_path__ + "static/media/chaise-haute-enfant.8efbeb9f.svg";